import React, { Component } from "react";
import Cookies from "js-cookie";

class SessionTimeout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirecting: false,
    };
    this.sessionTimer = null;
    this.resetTimer = this.resetTimer.bind(this);
  }

  componentDidMount() {
    const usermobile = localStorage.getItem("usermobile");
    // this.timeoutDuration = usermobile === "8800824299" ? 30 * 60 * 1000 : 5 * 60 * 1000;
    this.timeoutDuration = 6 * 60 * 60 * 1000  // 6 hours
    

    console.log("User Mobile:", usermobile);
    console.log("Timeout Duration Set To:", this.timeoutDuration);

    Cookies.set("sessionStart", new Date().toISOString());
    this.startSessionTimer();
    window.addEventListener("mousemove", this.resetTimer);
    window.addEventListener("keydown", this.resetTimer);

    this.blockHistoryNavigation();
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this.resetTimer);
    window.removeEventListener("keydown", this.resetTimer);
    window.removeEventListener("popstate", this.preventBackNavigation);
    clearInterval(this.sessionTimer);
  }

  blockHistoryNavigation() {
    window.history.pushState(null, null, window.location.href);

    this.preventBackNavigation = () => {
      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener("popstate", this.preventBackNavigation);
  }

  startSessionTimer() {
    this.sessionTimer = setInterval(() => {
      const sessionStart = Cookies.get("sessionStart");
      const currentTime = new Date().getTime();
      const sessionTime = sessionStart ? new Date(sessionStart).getTime() : 0;

      console.log("Current Time:", currentTime);
      console.log("Session Start:", sessionStart);
      console.log("Session Time:", sessionTime);
      console.log("Timeout Duration:", this.timeoutDuration);
      console.log("Time Elapsed:", currentTime - sessionTime);

      if (currentTime - sessionTime >= this.timeoutDuration) {
        console.log("Session Timeout Triggered");
        this.handleSessionTimeout();
      }
    }, 3000); // Check every 3 seconds
  }

  resetTimer() {
    console.log("Session Reset!");
    Cookies.set("sessionStart", new Date().toISOString());
  }

  handleSessionTimeout() {
    clearInterval(this.sessionTimer);
    console.log("Redirecting to login...");

    localStorage.clear();
    window.history.pushState(null, null, "/");
    window.location.replace("/");
  }

  render() {
    return null; // No UI needed
  }
}

export default SessionTimeout;
